import React, { useEffect, useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

// Mock data for members with distinct dummy logos
// const membersData = [
//   {
//     id: 1,
//     name: 'ItalBangla Textiles',
//     website: 'www.italbanglatextiles.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=IBT', 
//   },
//   {
//     id: 2,
//     name: 'Venezia Leather Works',
//     website: 'www.venezialeather.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=VLW',
//   },
//   {
//     id: 3,
//     name: 'AgriTech Solutions BD',
//     website: 'www.agritech-bd.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=AT',
//   },
//   {
//     id: 4,
//     name: 'Roma Trade Syndicate',
//     website: 'www.romatrade.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=RTS',
//   },
//   {
//     id: 5,
//     name: 'Milano Ceramic Corp',
//     website: 'www.milanoceramic.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=MCC',
//   },
//   {
//     id: 6,
//     name: 'Genoa Maritime',
//     website: 'www.genoamaritime.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=GM',
//   },
//   {
//     id: 7,
//     name: 'Florentine Apparels',
//     website: 'www.florentineapparels.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=FA',
//   },
//   {
//     id: 8,
//     name: 'TechBari Innovations',
//     website: 'www.techbari.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=TBI',
//   },
//   {
//     id: 9,
//     name: 'Napoli Food Importers',
//     website: 'www.napolifoods-bd.com',
//     logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=NFI',
//   }
// ];
const membersData = [
  { name: 'Member 1', website: 'www.member1.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M1' },
  { name: 'Member 2', website: 'www.member2.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M2' },
  { name: 'Member 3', website: 'www.member3.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M3' },
  { name: 'Member 4', website: 'www.member4.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M4' },
  { name: 'Member 5', website: 'www.member5.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M5' },
  { name: 'Member 6', website: 'www.member6.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M6' },
  { name: 'Member 7', website: 'www.member7.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M7' },
  { name: 'Member 8', website: 'www.member8.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M8' },
  { name: 'Member 9', website: 'www.member9.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M9' },
  { name: 'Member 10', website: 'www.member10.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M10' },
  { name: 'Member 11', website: 'www.member11.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M11' },
  { name: 'Member 12', website: 'www.member12.com', logo: 'https://placehold.co/300x150/F8F7F3/0F1C35?text=M12' },
];

export default function MembersPage() {
  const ref = useRef<HTMLDivElement>(null);

  // Scroll to top on load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Intersection Observer for the initial scroll reveal animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = ref.current?.querySelectorAll('.reveal-elem');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []); 

  return (
    <div className="relative min-h-screen bg-white font-sans">
      <Navbar />
      
      <main className="pt-20">
        
        {/* Header Section */}
        <section className="py-20 md:py-28" style={{ backgroundColor: '#0F1C35' }}>
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24 text-center">
            
            

            <h1 
              className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 tracking-tight"
              style={{ color: '#C9952A' }}
            >
              Members & Partners
            </h1>
            
            <p 
              className="text-base md:text-lg max-w-2xl mx-auto leading-relaxed"
              style={{ color: '#A0ABC0' }}
            >
              Discover the businesses actively shaping the bilateral trade corridor between Bangladesh and Italy.
            </p>

          </div>
        </section>

        {/* Members Grid Section */}
        <div ref={ref} className="w-full px-6 md:px-10 lg:px-16 xl:px-24 py-16 md:py-24" style={{ backgroundColor: '#F8F7F3' }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
            {membersData.map((member, i) => (
              <div
                key={member.id}
                className="reveal-elem opacity-0 translate-y-8 transition-all duration-700 ease-out flex flex-col items-center justify-center text-center p-8 rounded-2xl bg-white"
                style={{ 
                  transitionDelay: `${(i % 3) * 100}ms`,
                  border: '1px solid #E5E7EB',
                  boxShadow: '0 4px 20px rgba(15, 28, 53, 0.03)'
                }}
              >
                {/* Partner Logo */}
                <div className="h-24 w-full flex items-center justify-center mb-6">
                  <img 
                    src={member.logo} 
                    alt={`${member.name} logo`} 
                    className="max-h-full max-w-full object-contain"
                  />
                </div>

                {/* Company Name */}
                <h3 className="text-xl font-bold mb-3" style={{ color: '#0F1C35' }}>
                  {member.name}
                </h3>

                {/* Website Link */}
                <a 
                  href={`https://${member.website}`} 
                  target="_blank" 
                  rel="noreferrer"
                  className="text-sm font-medium hover:underline flex items-center gap-2"
                  style={{ color: '#C9952A' }}
                >
                  <i className="ri-global-line"></i>
                  {member.website}
                </a>
              </div>
            ))}
          </div>
        </div>
      </main>
      
     
    </div>
  );
}